import {
  PartialVarsResolver,
  CheckboxFactory,
  MantineTheme,
  CheckboxStylesNames,
  CheckboxProps,
  rem
} from '@mantine/core';

import classes from './Checkbox.module.css';

export const DefaultCheckboxProps: Partial<CheckboxProps> = {
  size: 'xs',
  radius: 'sm'
};

export const CheckboxOverridesClassNames: (
  theme?: MantineTheme,
  props?: CheckboxProps
) => Partial<Record<CheckboxStylesNames, string>> = () => {
  return {
    input: classes.input,
    label: classes.label,
    error: classes.error
  };
};

export const CheckboxGroupOverridesClassNames: () => Partial<
  Record<CheckboxStylesNames, string>
> = () => {
  return {
    error: classes.errorCheckboxGroup
  };
};

export const CheckboxVarsResolver: PartialVarsResolver<CheckboxFactory> = (
  _theme: MantineTheme,
  props: CheckboxProps
) => {
  if (props.radius === 'xs') {
    return {
      root: {
        '--checkbox-radius': rem(2)
      }
    };
  } else if (props.radius === 'sm') {
    return {
      root: {
        '--checkbox-radius': rem(4)
      }
    };
  } else if (props.radius === 'md') {
    return {
      root: {
        '--checkbox-radius': rem(8)
      }
    };
  } else if (props.radius === 'lg') {
    return {
      root: {
        '--checkbox-radius': rem(16)
      }
    };
  } else if (props.radius === 'xl') {
    return {
      root: {
        '--checkbox-radius': rem(32)
      }
    };
  }

  return {
    root: {
      '--checkbox-radius': rem(4)
    }
  };
};
